import { styled, TooltipProps, Tooltip, tooltipClasses } from '@mui/material';

export const OrderMFlexQRIconWithTooltip = styled(
  ({ className, ...restProps }: TooltipProps) => (
    <Tooltip {...restProps} classes={{ popper: className }} />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,

    '&::before': {
      border: `1px solid ${theme.palette.common.black}`,
    },
  },

  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.black}`,
    padding: theme.spacing(4),
  },
}));
